export default "__VITE_ASSET__BMAP8rqP__"